import { FrontendEnvSchema } from '@envSchema';

// Filter out all keys that are not prefixed with VITE_
const filteredEnv = Object.fromEntries(
  Object.entries(import.meta.env).filter(([key]) => key.startsWith('VITE_')),
);

export const FRONTEND_ENV = FrontendEnvSchema.parse(filteredEnv);

console.log('FRONTEND_ENV', FRONTEND_ENV);
